import { ReactNode, useContext } from "react";
import { APIContext } from "../Contexts/APIContext";
import IconButton from "@mui/material/IconButton";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { Breakpoint } from "@mui/material";
interface IProps {
    title: string;
    content: ReactNode;
    type: "warning" | "error" | "info";
    label?: string;
    size?: "small" | "medium"
    dialogSize?: Breakpoint;
}

export default function WarningPopup(props: IProps) {
    const { openDialog } = useContext(APIContext);

    const handleOpenDialog = () => {
        openDialog(props.content, [], props.title, undefined, props.dialogSize);
    }
    return (
        <>
            <Tooltip title="Warning!">
                {props.label ?
                    <Button onClick={handleOpenDialog}>{props.label}</Button>
                    :
                    <IconButton onClick={handleOpenDialog} size={props.size ?? "small"} sx={{ p: 0, m: 0 }}>
                        {props.type === "warning" ?
                            <WarningAmberIcon htmlColor="#FFBF00" />
                            :
                            <WarningAmberIcon color={props.type} />
                        }
                    </IconButton>
                }
            </Tooltip>
        </>
    );
}
